import { PRODUCTS_SUCCESSFUL_FETCH } from 'reducers/constants';

const initialState = {
    items: [],
    item: {}
}

export default function (state = initialState, action) {
    switch (action.type) {
        case PRODUCTS_SUCCESSFUL_FETCH:
            return {
                ...state,
                items: action.payload.slice()
            }
            
        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/product/productReducer.js